import React from "react";

const InstagramFilled = ({ ...rest }) => (
  <svg
    {...rest}
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.666016"
      width="39"
      height="39"
      rx="19.5"
      fill="#FAFAFA"
    />
    <rect
      x="0.5"
      y="0.666016"
      width="39"
      height="39"
      rx="19.5"
      stroke="#E5E5E5"
    />
    <g clip-path="url(#clip0_1701_15878)">
      <path
        d="M20 10.327C23.2063 10.327 23.5859 10.341 24.8469 10.3973C26.0188 10.4488 26.6516 10.6457 27.0734 10.8098C27.6313 11.0254 28.0344 11.2879 28.4516 11.7051C28.8734 12.127 29.1313 12.5254 29.3469 13.0832C29.5109 13.5051 29.7078 14.1426 29.7594 15.3098C29.8156 16.5754 29.8297 16.9551 29.8297 20.1566C29.8297 23.3629 29.8156 23.7426 29.7594 25.0035C29.7078 26.1754 29.5109 26.8082 29.3469 27.2301C29.1313 27.7879 28.8687 28.191 28.4516 28.6082C28.0297 29.0301 27.6313 29.2879 27.0734 29.5035C26.6516 29.6676 26.0141 29.8645 24.8469 29.916C23.5813 29.9723 23.2016 29.9863 20 29.9863C16.7938 29.9863 16.4141 29.9723 15.1531 29.916C13.9813 29.8645 13.3484 29.6676 12.9266 29.5035C12.3688 29.2879 11.9656 29.0254 11.5484 28.6082C11.1266 28.1863 10.8688 27.7879 10.6531 27.2301C10.4891 26.8082 10.2922 26.1707 10.2406 25.0035C10.1844 23.7379 10.1703 23.3582 10.1703 20.1566C10.1703 16.9504 10.1844 16.5707 10.2406 15.3098C10.2922 14.1379 10.4891 13.5051 10.6531 13.0832C10.8688 12.5254 11.1313 12.1223 11.5484 11.7051C11.9703 11.2832 12.3688 11.0254 12.9266 10.8098C13.3484 10.6457 13.9859 10.4488 15.1531 10.3973C16.4141 10.341 16.7938 10.327 20 10.327ZM20 8.16602C16.7422 8.16602 16.3344 8.18008 15.0547 8.23633C13.7797 8.29258 12.9031 8.49883 12.1438 8.79414C11.3516 9.10352 10.6813 9.51133 10.0156 10.1816C9.34531 10.8473 8.9375 11.5176 8.62813 12.3051C8.33281 13.0691 8.12656 13.941 8.07031 15.216C8.01406 16.5004 8 16.9082 8 20.166C8 23.4238 8.01406 23.8316 8.07031 25.1113C8.12656 26.3863 8.33281 27.2629 8.62813 28.0223C8.9375 28.8145 9.34531 29.4848 10.0156 30.1504C10.6813 30.816 11.3516 31.2285 12.1391 31.5332C12.9031 31.8285 13.775 32.0348 15.05 32.091C16.3297 32.1473 16.7375 32.1613 19.9953 32.1613C23.2531 32.1613 23.6609 32.1473 24.9406 32.091C26.2156 32.0348 27.0922 31.8285 27.8516 31.5332C28.6391 31.2285 29.3094 30.816 29.975 30.1504C30.6406 29.4848 31.0531 28.8145 31.3578 28.027C31.6531 27.2629 31.8594 26.391 31.9156 25.116C31.9719 23.8363 31.9859 23.4285 31.9859 20.1707C31.9859 16.9129 31.9719 16.5051 31.9156 15.2254C31.8594 13.9504 31.6531 13.0738 31.3578 12.3145C31.0625 11.5176 30.6547 10.8473 29.9844 10.1816C29.3188 9.51602 28.6484 9.10352 27.8609 8.79883C27.0969 8.50352 26.225 8.29727 24.95 8.24102C23.6656 8.18008 23.2578 8.16602 20 8.16602Z"
        fill="#000100"
      />
      <path
        d="M20 14.002C16.5969 14.002 13.8359 16.7629 13.8359 20.166C13.8359 23.5691 16.5969 26.3301 20 26.3301C23.4031 26.3301 26.1641 23.5691 26.1641 20.166C26.1641 16.7629 23.4031 14.002 20 14.002ZM20 24.1645C17.7922 24.1645 16.0016 22.3738 16.0016 20.166C16.0016 17.9582 17.7922 16.1676 20 16.1676C22.2078 16.1676 23.9984 17.9582 23.9984 20.166C23.9984 22.3738 22.2078 24.1645 20 24.1645Z"
        fill="#000100"
      />
      <path
        d="M27.8469 13.7574C27.8469 14.5543 27.2 15.1965 26.4078 15.1965C25.6109 15.1965 24.9688 14.5496 24.9688 13.7574C24.9688 12.9605 25.6156 12.3184 26.4078 12.3184C27.2 12.3184 27.8469 12.9652 27.8469 13.7574Z"
        fill="#000100"
      />
    </g>
    <defs>
      <clipPath id="clip0_1701_15878">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(8 8.16602)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default InstagramFilled;
